import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { linkEffect, linkHoverEffect } from '@design-system/theme';
export const BreadcrumbItem = ({ font, tab, useLinkEffectOnHoverOnly, }) => {
    const { active = false, dataTestId, disable = false, label, onClickAction, } = tab;
    const commonProps = {
        dataTestId,
        font,
    };
    if (disable) {
        return _jsx(Disabled, Object.assign({}, commonProps, { children: label }));
    }
    if (active || !onClickAction) {
        return _jsx(Box, Object.assign({}, commonProps, { children: label }));
    }
    return (_jsx(ClickableTab, Object.assign({}, commonProps, { "$linkHoverEffect": useLinkEffectOnHoverOnly, as: "a", onClick: onClickAction, tabIndex: 0, children: label })));
};
const ClickableTab = styled(Box) `
  ${({ $linkHoverEffect }) => $linkHoverEffect ? linkHoverEffect() : linkEffect()}
`;
const Disabled = styled(Box).attrs(({ theme }) => ({
    opacity: theme.input.disabled.opacity,
})) `
  cursor: default;
  pointer-events: none;
`;
//# sourceMappingURL=BreadcrumbItem.js.map